import React from 'react';
import { injectIntl } from 'react-intl';
import { PaymentElement } from '@stripe/react-stripe-js';

import { FieldCheckbox } from '..';

import css from './StripeCheckoutForm.module.css';

const StripePaymentElement = ({
  intl,
  label,
  showSaveCardCheckbox = false,
  paymentElementId = 'payment-element',
  onChange,
}) => {
  const paymentElementOptions = {
    layout: 'tabs',
  };

  const labelText =
    label || intl.formatMessage({ id: 'StripePaymentForm.saveAfterOnetimePayment' });

  return (
    <div className={css.paymentContainer}>
      <div>
        <PaymentElement
          id={paymentElementId}
          className={css.paymentElement}
          options={paymentElementOptions}
          onChange={onChange}
        />
      </div>
      {showSaveCardCheckbox ? (
        <div className={css.saveForLaterUse}>
          <FieldCheckbox
            className={css.saveForLaterUseCheckbox}
            textClassName={css.saveForLaterUseLabel}
            id="saveAfterOnetimePayment"
            name="saveAfterOnetimePayment"
            label={labelText}
            value="saveAfterOnetimePayment"
            useSuccessColor
          />
        </div>
      ) : null}
    </div>
  );
};

export default injectIntl(StripePaymentElement);
